import type { UseFormReturn } from "react-hook-form";

export const hasTriggerFormSubmit = (
  form: UseFormReturn<any>,
): form is UseFormReturn<any> & { triggerFormSubmit: () => void } =>
  "triggerFormSubmit" in form;
